import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import floatModal from './modules/floatModal';
import roi from './modules/roi';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    roi,
    floatModal
  }
});
